<div class="title">
  <h2>Add Quickflow</h2>
  <nav class="navigation-links">
    @for (menuItem of displayedMenuItems; track menuItem; let i = $index) {
    <div class="navigation-link-outer">
      <a class="navigation-link" [class.active]="menuItem.text === step" [class.disabled]="menuItem.text !== step">
        <p class="navigation-link__text">{{ menuItem.text }}</p>
      </a>
    </div>
    }
  </nav>
  <pdq-input
    #internal_name
    class="internal-name"
    placeholder="Internal name...."
    [formControl]="internalName"
    type="text">
  </pdq-input>
  <div class="close-btn" title="close" (click)="onClose()"></div>
</div>
<pdq-divider></pdq-divider>
<div class="body">
  <pdq-button icon="back" label="BACK" variant="ghost" (onClick)="onBackHandler()"> </pdq-button>
  <ng-template #target></ng-template>
</div>
<div class="body__actions">
  <pdq-button
    variant="primary"
    [disabled]="!(isActionInsertedProperly(selectedAction) && isConditionsInsertedProperly(selectedConditions) && isConditionsAndActionsWorkTogether(selectedConditions,selectedAction)) "
    (onClick)="addWorkflow()"
    label="Save Quickflow">
  </pdq-button>
</div>
